// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — toggle.classic.js, новая — toggle.cp.js
import { isCp } from 'libs/design';
import * as classic from './toggle.classic';
import * as cp from './toggle.cp';

export const Toggle = isCp ? cp.Toggle : classic.Toggle;
